import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { redirect } from 'redux-first-router';
import loadable from '@loadable/component';

import { usePortfolios } from '@/hooks/portfolio/usePortfolio';
import { useLegacyPortfolios } from '../../hooks/useLegacyPortfolios';

import { ROUTE_PORTFOLIO_NEW } from '@/constants/routes';

const MyPortfolios = loadable(() => import('../MyPortfolios'), {
  resolveComponent: (c) => c.MyPortfolios,
});

export const Landing = () => {
  const dispatch = useDispatch();

  const {
    keys: legacyPortfoliosKeys = [],
    isFetched: legacyPortfoliosIsFetched,
  } = useLegacyPortfolios();
  const { data: newPortfolios = [], isFetched: newPortfoliosIsFetched } =
    usePortfolios();

  const hasPortfolios =
    legacyPortfoliosKeys.length > 0 || newPortfolios.length > 0;
  const isPortfoliosFetched =
    legacyPortfoliosIsFetched && newPortfoliosIsFetched;

  useEffect(() => {
    if (isPortfoliosFetched && !hasPortfolios) {
      dispatch(redirect({ type: ROUTE_PORTFOLIO_NEW }));
    }
  }, [dispatch, isPortfoliosFetched, hasPortfolios]);

  return isPortfoliosFetched && hasPortfolios ? <MyPortfolios /> : null;
};
